<template>
  <div class="box-bottom">
    <textarea class="input-text" placeholder="输入想要发送的内容" v-model="content"></textarea>
    <button class="send-btn" @click="addMessage">确定</button>
    <section class="tool-wrapper">
      <span class="upImg">
        <input
          class="inputupload" type="file" accept="image/*" @change="upImg($event)"/>
      </span>
      <span class="upfile">
        <input
          class="inputupload" type="file" accept=".pdf,.ppt,.pptx,.doc,.docx" @change="upFile($event)"/>
      </span>
      <span class="upword">
        <input
          class="inputupload" type="file" accept=".pdf,.ppt,.pptx,.doc,.docx" @change="upFile2($event)"/>
      </span>

    </section>
  </div>
</template>

<script type="text/ecmascript-6">

  import {getYearMonthDay, getHourMinutes} from "@/common/js/getYearMonthDay";

  export default {
    props: {
      id:{
        type:String
      },
      isFirstSent: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        content: '',
        filename: '',
        filesize: 0,
      }
    },
    methods: {
      addMessage() {
        let message = this.content.trim();
        if (!message == '') {
          //listtype:1为老师，2为学生
          //infotype:1为text，2为图片，3为音频
          let content = {listtype: "2", infotype: "1", text: this.content};
          if (this.isFirstSent) {
            let date = new Date();
            content.time = getYearMonthDay(date) + ' ' + getHourMinutes(date);
          }
          this.$emit('sendmessage', content)
          this.content = '';
        }
      },
      upImg: function (e) {
        let input = e.target;
        // 通过DOM取文件数据
        let file = input.files[0];
        // let reader = new FileReader();
        // reader.readAsDataURL(file);
        let xhr = new XMLHttpRequest();
        //initiate request
        let url = '/indexapp.php?c=Upload&a=UploadFileNew&id=' + this.id;
        xhr.open('post', url, true);
        //set headers
        xhr.setRequestHeader('X-File-Name', encodeURI(file.name));
        xhr.setRequestHeader('X-File-Size', file.size);
        xhr.setRequestHeader('X-File-Type', file.type);
        xhr.addEventListener('load', this.uploadComplete, false);
        //send the file
        xhr.send(file);
      },
      uploadComplete: function (evt) {
        let response = evt.target.responseText;
        let jsonobj = JSON.parse(response);
        console.log(jsonobj)
        let content = {listtype: "2", infotype: "2", image: jsonobj.image,imagewidth:jsonobj.imagewidth,imageheight:jsonobj.imageheight};
        if (this.isFirstSent) {
          let date = new Date();
          content.time = getYearMonthDay(date) + ' ' + getHourMinutes(date);
        }
        this.$emit('sendmessage', content)
        // this.$set(this.introduceList[this.index], 'image', jsonobj.image);
        // this.$set(this.introduceList[this.index], 'width', jsonobj.imagewidth);
        // this.$set(this.introduceList[this.index], 'height', jsonobj.imageheight);
        this.$forceUpdate();

      },
      upFile: function (e) {
        this.loading = this.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let input = e.target;
        // 通过DOM取文件数据
        let file = input.files[0];
        // let reader = new FileReader();
        // reader.readAsDataURL(file);
        let xhr = new XMLHttpRequest();
        //initiate request
        let url = '/indexapp.php?c=Upload&a=UploadFileNew&id=' + this.id;
        xhr.open('post', url, true);
        //set headers
        xhr.setRequestHeader('X-File-Name', encodeURI(file.name));
        xhr.setRequestHeader('X-File-Size', file.size);
        xhr.setRequestHeader('X-File-Type', file.type);
        xhr.addEventListener('load', this.uploadFileComplete, false);
        //send the file
        xhr.send(file);
      },
      upFile2: function (e) {
        this.loading = this.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let input = e.target;
        // 通过DOM取文件数据
        let file = input.files[0];
        this.filename = file.name;
        this.filesize = file.size;

        let xhr = new XMLHttpRequest();
        let that = this;

        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = (e) => {
          console.log(e.target.result)
          let url = '/indexapp.php?c=Upload&a=UploadFileMd5';
          xhr.open('post', url, true);

          xhr.addEventListener('load', this.uploadFileComplete2, false);
          //send the file
          // xhr.send(file);
          let formData = new FormData();
          formData.append('id', that.id);
          formData.append('file', new Blob([e.target.result]));
          formData.append('filename', file.name);
          xhr.send(formData);
        }

        //initiate request

      },
      uploadFileComplete: function (evt) {
        let response = evt.target.responseText;
        let jsonobj = JSON.parse(response);
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Upload',
            a: 'ImportImagesFromFile',
            id: this.id,
            uploadfilename: jsonobj.image
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            response.list.forEach((item,index)=>{
              let content = {listtype: "2", infotype: "2", image: item.filename,imagewidth:100,imageheight:100};
              if (this.isFirstSent&&index==0) {
                let date = new Date();
                content.time = getYearMonthDay(date) + ' ' + getHourMinutes(date);
              }
              this.$emit('sendmessage', content)
            })
            this.loading.close();
          }else{
            this.loading.close();
          }
        }).catch((err) => {
          console.log(err)
        });
      },
      uploadFileComplete2: function (evt) {
        let response = evt.target.responseText;
        let jsonobj = JSON.parse(response);
        this.loading.close();
        let content = {
          listtype: "2",
          infotype: "4",
          filename: this.filename,
          filepath: jsonobj.image,
          filesize: this.filesize
        };
        if (this.isFirstSent) {
          let date = new Date();
          content.time = getYearMonthDay(date) + ' ' + getHourMinutes(date);
        }
        this.$emit('sendmessage', content)
        this.$forceUpdate();

      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .box-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 150px;
    background: #fff
    .input-text {
      padding: 15px 20px 0;
      width: 100%;
      height: 85px;
      border: none;
      outline: none;
      box-sizing: border-box
      resize: none
      font-size: 16px;
      color: #333;
      line-height: 21px;
    }
    .send-btn {
      position: absolute;
      bottom: 15px;
      right: 20px;
      display: inline-block;
      width: 120px;
      height: 40px;
      line-height: 40px;
      border-radius: 4px;
      font-size: 16px;
      color: #333;
      border: 1px solid #e9e9e9
    }
    .tool-wrapper{
      position:absolute;
      left:20px;
      bottom:15px;
      height:26px;
      .upImg, .upfile, .upword {
        margin-right: 30px;
        display: inline-block;
        width: 26px;
        height: 26px;
        cursor: pointer
        position: relative
      }
      .upImg {
        background: url('./upphoto.png') no-repeat center / 26px
      }
      .upfile {
        background: url('./upfiletophoto.png') no-repeat center / 26px
      }
      .upword {
        background: url('./upfile.png') no-repeat center / 26px
      }
      .inputupload{
        position: absolute
        left: 0
        top: 0
        height: 100%
        width: 100%
        padding: 0
        margin: 0
        opacity: 0
        cursor: pointer
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/homework/studentchatbottom.vue